import { Box, IconButton } from "@mui/material";
import { DeleteIcon, EyeIcon } from "../../../../assets/svgComponents";
import { CardContainer } from "./blockoff-card.styles";
import { v4 as uuid } from "uuid";
import { convertTo12HourFormat } from "../../tabs-content/blockoffs/blockoffs.utils";
import OverflowText from "../../../../components/overflow-text/overflow-text";

interface CardProps {
  blockoff: {
    label: string;
    list: any[];
  };
  handleView: (event: any) => void;
  handleDelete: (event: any) => void;
}

const BlockoffCard: React.FC<CardProps> = ({
  blockoff,
  handleView,
  handleDelete,
}) => {
  const blockoffList = blockoff.list;
  return (
    <CardContainer>
      <h4 style={{ margin: "10px 0px" }}>{blockoff.label}</h4>
      <Box className="blockoff-wrapper">
        {blockoffList.length > 0 ? (
          blockoffList.map((event, index) => (
            <Box key={`${uuid()}_${event?.id}`} className="event-item">
              <Box className="event-details">
                <OverflowText>{event?.reason}</OverflowText>

                <span style={{ fontSize: "15px" }}>
                  {convertTo12HourFormat(event.start_time)} -{" "}
                  {convertTo12HourFormat(event.end_time)}
                </span>
              </Box>
              <Box className="event-icons">
                <IconButton
                  className="view-icon"
                  onClick={() =>
                    handleView({ ...event, label: blockoff.label })
                  }
                >
                  <EyeIcon />
                </IconButton>
                <IconButton
                  className="delete-icon"
                  onClick={() =>
                    handleDelete({ ...event, label: blockoff.label })
                  }
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            </Box>
          ))
        ) : (
          <p>No events for this day.</p>
        )}
      </Box>
    </CardContainer>
  );
};

export default BlockoffCard;
